import type { RootState } from '@app/store';
import { AUTH } from '@app/store/constants/constants';
import type { NAuth } from '@app/types/Auth';

// Стабильная ссылка на пустой список: у persisted-состояния, сохранённого до
// появления поля organizations, ключа нет, а возврат нового [] на каждый вызов
// селектора ронял бы useAppSelector в цикл ререндеров.
const EMPTY_ORGANIZATIONS: NAuth.ModelOrganizationAuth[] = [];

export const selectUser = (state: RootState) => state[AUTH].user;
export const selectAccessRights = (state: RootState) => state[AUTH].accessRights; // prettier-ignore
export const selectActiveBranchName = (state: RootState) =>
  state[AUTH].activeBranchName;
export const selectActiveBranchCountryId = (state: RootState) =>
  state[AUTH].activeBranchCountryId;
export const selectOrganizations = (state: RootState) =>
  state[AUTH].organizations ?? EMPTY_ORGANIZATIONS;
